import { useMutation } from '@tanstack/react-query';
import axios from '../axios';

const useLogin = ({ onSuccess, onError }) => {
  const mutation = useMutation({
    mutationFn: async (params) => {
      const response = await axios.post("/api/auth/login", {
        email: params.email,
        password: params.password,
      });
      return response;
    },
    onSuccess,
    onError,
  });

  return mutation;
};

export default useLogin;
